import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Trim whitespace from inputs
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    // Simulate login delay
    setTimeout(() => {
      // Admin credentials
      if (trimmedUsername === 'report' && trimmedPassword === 'report123') {
        console.log('✅ Admin login successful!');
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', trimmedUsername);
        localStorage.setItem('userRole', 'admin');
        onLogin();
      } 
      // HR Admin credentials
      else if (trimmedUsername === 'hradmin' && trimmedPassword === 'hr345') {
        console.log('✅ HR Admin login successful!');
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', trimmedUsername);
        localStorage.setItem('userRole', 'hradmin');
        onLogin();
      } 
      else {
        setError('Invalid username or password. Please try again.');
        console.log('❌ Login failed - Username:', trimmedUsername, 'Password:', trimmedPassword);
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-section">
            <h1>IFEC Report</h1>
          </div>
          <p className="login-subtitle">Daily Production Management System</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <div className="input-wrapper">
              <span className="input-icon">👤</span>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                required
                autoComplete="username"
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                autoComplete="current-password"
                disabled={loading}
              />
            </div>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className={`login-button ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>

      <div className="login-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  );
};

export default Login;

